module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-4-cea8087a8c08894c3a314919d3a3ae8c.svg";